/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { GoogleMap, LoadScript, Marker, MarkerClusterer } from '@react-google-maps/api';
import React, { useEffect, useState } from 'react';

const containerStyle = {
  height: '100%',
};

const SmartFeederMap = ({ feeder, cameras }) => {
  const [map, setMap] = useState<any>();

  useEffect(() => {
    if (feeder) {
      fitBounds(map);
    }
  }, [cameras, feeder]);

  const loadHandler = (mapInstance) => {
    setMap(mapInstance);
  };

  const fitBounds = (mapInstance) => {
    if (mapInstance) {
      const bounds = new window.google.maps.LatLngBounds();
      if (cameras.length > 0) {
        cameras.forEach((child) => {
          bounds.extend({ lat: Number(child.latitude), lng: Number(child.longitude) });
        });
      }
      if (feeder.latitude != '0') {
        bounds.extend({ lat: Number(feeder.latitude), lng: Number(feeder.longitude) });
      }
      mapInstance.fitBounds(bounds);
    }
  };

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyCq6ONxMlIEgAGnMaepx6qmCWB0KmN_PnE"
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        onLoad={loadHandler}
        zoom={14}
        options={{
          mapTypeControl: false,
          mapTypeId: 'hybrid',
        }}
      >
        <MarkerClusterer
          options={{
            imagePath: '/cluster_icons/m',
          }}
        >
          {(clusterer) => (
            (cameras?.length > 0)
              ? cameras.map((e, i) => (
                <Marker
                  key={i}
                  title={e.name}
                  clusterer={clusterer}
                  icon={{ url: `/map_pins/${e.type ? e.type : 'Camera'}-gray.png` }}
                  position={{ lat: Number(e.latitude), lng: Number(e.longitude) }}
                />
              )) : null)}
        </MarkerClusterer>
        {feeder && (
          <Marker
            title={feeder.name}
            position={{ lat: Number(feeder.latitude), lng: Number(feeder.longitude) }}
            zIndex={100}
            icon={{ url: '/map_pins/Feeder.png' }}
          />
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default SmartFeederMap;
